import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from "./store";
import '../src/config/element.config'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.min.css'

import CalendarItem from "./components/PCComponents/CalendarItem"
import MobileCalendarItem from "./components/MobileComponents/CalendarItem"
import PaneTitle from "./components/PCComponents/PaneTitle"
import MobilePaneTitle from "./components/MobileComponents/PaneTitle"
import BackHome from "./components/MobileComponents/BackHome";
import NavList from "./components/MobileComponents/NavList";
import LanguageBtn from './components/PCComponents/LanguageBtn';
import MBanner from './components/MobileComponents/Banner';
import SearchInput from "./components/MobileComponents/SearchInput";
import Viser from 'viser-vue'

import $http from './api'

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview, {
  fullscreenEl: false,
  closeEl: true,
  tapToClose: true,
  shareEl: false,
  zoomEl: false,
  counterEl: true,
  arrowEl: true,
  tapToToggleControls: true,
  clickToCloseNonZoomable: true
});

import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css');

Vue.use(VideoPlayer)

// import vconsole from 'vconsole'

Vue.prototype.$http = $http;

Vue.use(VueAwesomeSwiper)
Vue.use(Viser)

Vue.component('pane-title', PaneTitle);
Vue.component('m-pane-title', MobilePaneTitle)
Vue.component('calendar-item', CalendarItem);
Vue.component('m-calendar-item', MobileCalendarItem);
Vue.component('back-home', BackHome);
Vue.component('nav-list', NavList);
Vue.component('lan-btn', LanguageBtn);
Vue.component('m-banner', MBanner);
Vue.component('search-input', SearchInput);
Vue.config.productionTip = false

Vue.prototype.$mlang = 'zh';

// new vconsole();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
